import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { IndexCard, UgerapportUge, Timereg, TimetrackDescription, Ugerapport, UgerepDone } from '@store/models';
import { LuxonUtils } from '@shared';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientCasesDetailsContainerComponent } from 'app/shared/client-cases-details/client-cases-details.container';
import { NavigationService } from '../../core/navigation.service';

@Component({
    selector: 'app-time-log-ui',
    templateUrl: './time-log.component.html',
    styleUrls: ['../timetrack.shared.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TimeLogComponent {

    @Input() user: IndexCard;
    @Input() year: number;
    @Input() week: number;
    @Input() today: number;
    @Input() weekTotals: number[];
    @Input() ugerapport: UgerapportUge[];
    @Input() normtiderWeek: number[];
    @Input() ugerepDoneWeek: boolean[];
    @Output() saveTimer = new EventEmitter<Partial<Timereg>>();
    @Output() saveBeskrivelse = new EventEmitter<TimetrackDescription>();
    @Output() doneDay = new EventEmitter<UgerepDone>();

    displayColumns = [
        'glkundenr', 'kunde', 'sag', 'timerDag1', 'timerDag2', 'timerDag3', 'timerDag4', 'timerDag5', 'timerDag6', 'timerDag7', 'ialt', 'rest', 'sagskort'
    ];

    get weekHeaders() {
        return LuxonUtils.datesInWeek(this.year, this.week);
    }

    get weekTotalsSum() {
        return this.weekTotals.reduce((acc, cur) => acc + cur, 0);
    }

    get normtiderSum() {
        return this.normtiderWeek.reduce((acc, cur) => acc + cur, 0);
    }

    get weekTotalsDiff() {
        return this.weekTotalsSum - this.normtiderSum;
    }

    constructor(
        private router: Router,
        private activeModal: NgbActiveModal,
        private modal: NgbModal,
        private navigationService: NavigationService
    ) {}

    trackByPid(_: number, sag: UgerapportUge) {
        return sag.pid;
    }

    onSaveTimer(updateData: {timer: number, beskrivelse: string}, sag: UgerapportUge, dag: number) {
        const partialTimereg: Partial<Timereg> = {
            medId: this.user.cardId,
            kontor: this.user.kontor,
            sagID: sag.pid,
            dato: LuxonUtils.dateInWeek(this.year, this.week, dag),
            beskrivelse: updateData.beskrivelse,
            timer: updateData.timer,
            registreret: new Date()
        };
        this.saveTimer.emit(partialTimereg);
    }

    onSaveBeskrivelse(beskrivelse: string, sag: UgerapportUge, dag: number) {
        const timeTrackdescription: TimetrackDescription = {
            dato: LuxonUtils.dateInWeek(this.year, this.week, dag),
            beskrivelse,
            sagID: sag.pid,
            medId: sag.timeRegistrations[0]?.medId,
            kontor: sag.timeRegistrations[0]?.kontor
        };
        this.saveBeskrivelse.emit(timeTrackdescription);
    }

    onClient(kid: number) {
        this.router.navigate(['clients', kid.toString()]);
        this.activeModal.close();
    }


    async onCase(sag: Ugerapport) {
        this.activeModal.close();
        await this.navigationService.openCase(sag.kid?.toString(), sag.pid?.toString(), sag.v2RegnskabsaarKundeId, sag.yid);
    }

    onDoneDay(day: number) {
        const ugerepDone: UgerepDone = {
            id: 0,
            mid: this.user.cardId,
            dato: LuxonUtils.dateInWeek(this.year, this.week, day + 1),
            cd: new Date(),
            kontor: this.user.kontor
        };
        this.doneDay.emit(ugerepDone);
    }

    onCaseCard(kid: number) {
        const caseCard = this.modal.open(ClientCasesDetailsContainerComponent, { size: 'lg'});
        caseCard.componentInstance.kid = kid;
    }

}
